<div class="container-boxes">
    @for (box of homeBoxes; track box.name) {
        <a class="option-box" [routerLink]="box.routerLink">
            <fa-duotone-icon class="box-icon" [icon]="box.icon"></fa-duotone-icon>
            <span class="box-title">{{ box.name }}</span>
        </a>
    }
    @if (homeBoxes.length === 0) {
        <p class="no-access">No tienes acceso a ninguna sección todavía. Contacta con un administrador para que te asigne un rol.</p>
    }
</div>